import React from 'react';

export const Warning = (props: any) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="10 10 20 20"
    preserveAspectRatio="xMinYMin meet"
  >
    <path
      fillRule="evenodd"
      d="M20 11.53A8.47 8.47 0 0128.47 20 8.47 8.47 0 0120 28.47 8.47 8.47 0 0111.53 20 8.47 8.47 0 0120 11.53zm0 1.411a7.06 7.06 0 100 14.118 7.06 7.06 0 000-14.118zm0 9.883a.706.706 0 110 1.411.706.706 0 010-1.411zm0-7.06c.37 0 .672.284.703.646l.003.06v4.236a.706.706 0 01-1.409.061l-.003-.061V16.47c0-.39.316-.706.706-.706z"
    />
  </svg>
);

export const TrianglebleWarning = (props: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4018_7323)">
      <path
        d="M15.8263 13.2504L9.15378 1.65696C8.65335 0.795093 7.34665 0.767291 6.84622 1.65696L0.173729 13.2504C-0.326708 14.1123 0.312739 15.2243 1.34141 15.2243H14.6586C15.6873 15.2243 16.3267 14.1401 15.8263 13.2504ZM8.0139 10.8316C8.70895 10.8316 9.2928 11.4155 9.2928 12.1105C9.2928 12.8334 8.70895 13.3894 8.0139 13.3894C7.29105 13.3894 6.73501 12.8334 6.73501 12.1105C6.73501 11.4155 7.29105 10.8316 8.0139 10.8316ZM6.79061 6.24429C6.76281 6.04968 6.92962 5.88286 7.12424 5.88286H8.87576C9.07038 5.88286 9.23719 6.04968 9.20939 6.24429L9.01478 10.0254C8.98697 10.22 8.84796 10.3312 8.68115 10.3312H7.31885C7.15204 10.3312 7.01303 10.22 6.98523 10.0254L6.79061 6.24429Z"
        fill="#C9311A"
      />
    </g>
    <defs>
      <clipPath id="clip0_4018_7323">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
